import React from "react";
import { useState, useEffect, useRef } from "react";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Scrollbar from "react-scrollbars-custom";
import {
  deleteGroupPerson,
  addGroupPerson,
  fetchNewChatSearch,
  fetchGroupInfo,
  fetchDeleteGroup,
  fetchPersonInfo,
  changeGroupName,
} from "../../api/chatApi";
import { timeout } from "../../helpers/utilities";
import { roleNames } from "../../helpers/roleNames";
import { DebounceInput } from "react-debounce-input";
import { fetchConversationFiles } from "./../../api/chatApi";
import i18n from "./../../i18n";

const ParticipantInfo = ({
  hideParticipantChatInfo,
  groupId,
  personId,
  user,
  deleteGroupHandler,
  selectedContactNameChangeHandler,
}) => {
  const [contactsList, setcontactsList] = useState([]);
  const [onlyGroupMembers, setOnlyGroupMembers] = useState(true);
  const [filter, setFilter] = useState("");
  const [isPersonsLoading, setIsPersonsLoading] = useState(false);
  const [prevPosition, setPrevPosition] = useState(0);
  const [loadMore, setLoadMore] = useState(true);
  const [groupInfo, setGroupInfo] = useState({});
  const [personInfo, setPersonInfo] = useState(null);

  let groupChatUsersScroll = useRef(null);
  const filterSearchResults = async (withMore) => {
    try {
      setIsPersonsLoading(true);
      let skip = withMore ? contactsList.length : 0;
      let res = await fetchNewChatSearch({
        filter: filter,
        skip: skip,
        groupId: groupId,
        shoOnlyGroup: onlyGroupMembers,
      });
      if (withMore) {
        setcontactsList([...contactsList, ...res]);
        setLoadMore(res.length > 10);
        await timeout(20);
        groupChatUsersScroll.current.scrollTo(0, prevPosition + 10);
      } else {
        setcontactsList(res);
        setLoadMore(true);
      }
      setIsPersonsLoading(false);
    } catch (exception) {
      setIsPersonsLoading(false);
    }
  };

  const fetchGroup = async () => {
    let groupInfo = await fetchGroupInfo(groupId);
    setGroupInfo(groupInfo);
  };

  const fetchPerson = async () => {
    let personInfo = await fetchPersonInfo(personId);
    setPersonInfo(personInfo);
  };

  const [files, setFiles] = useState([]);

  const fetchFiles = async (id, isGroup) => {
    let files = await fetchConversationFiles(id, isGroup);
    setFiles(files);
  };

  useEffect(() => {
    if (groupId) filterSearchResults();
  }, [onlyGroupMembers, filter, groupId]);

  useEffect(() => {
    if (groupId) fetchGroup();
    else if (personId) fetchPerson();
    fetchFiles(groupId ? groupId : personId, !!groupId);
  }, [groupId, personId]);

  const onUpdateContactListScrollbar = () => {
    if (
      groupChatUsersScroll.current.scrollValues.clientHeight + groupChatUsersScroll.current.scrollValues.scrollTop ===
      groupChatUsersScroll.current.scrollValues.contentScrollHeight
    ) {
      if (!isPersonsLoading && loadMore) {
        setPrevPosition(groupChatUsersScroll.current.scrollValues.scrollTop);
        filterSearchResults(true);
      }
    }
  };

  // const userInfo = participantChatDetails.ParticipantInfo;
  // const files = participantChatDetails.files;
  // const media = participantChatDetails.media;
  // console.log("participantChatDetails", userInfo);

  const removeFromGroup = async (id) => {
    try {
      await deleteGroupPerson(id, groupId);
      setGroupInfo({ ...groupInfo, personsCount: groupInfo.personsCount - 1 });
      let ind = contactsList.findIndex((c) => c.id === id);
      contactsList.splice(ind, 1);
      setcontactsList([...contactsList]);
    } catch (exception) {}
  };

  const addToGroup = async (id) => {
    try {
      await addGroupPerson(id, groupId);
      setGroupInfo({ ...groupInfo, personsCount: groupInfo.personsCount + 1 });
      let item = contactsList.find((c) => c.id === id);
      item.inGroup = true;
      setcontactsList([...contactsList]);
    } catch (exception) {}
  };

  const deleteGroup = async (id) => {
    if (window.confirm("გსურთ ჯგუფის წაშლა?")) {
      try {
        await fetchDeleteGroup(id);
        deleteGroupHandler(id);
      } catch (exception) {}
    }
  };

  const [editMode, setEditMode] = useState(false);

  const [groupNameEdit, setGroupNameEdit] = useState(groupInfo.groupName);

  useEffect(() => {
    setGroupNameEdit(groupInfo.groupName);
  }, [groupInfo.groupName]);

  const setEditHandle = async () => {
    if (!editMode) {
      setEditMode(true);
      setGroupNameEdit(groupInfo.groupName);
    } else if (groupNameEdit.trim()) {
      await changeGroupName(groupId, groupNameEdit);
      setEditMode(false);
      setGroupInfo({ ...groupInfo, groupName: groupNameEdit });
      selectedContactNameChangeHandler(groupNameEdit);
    }
  };

  const determineEnterClick = (e) => {
    if (e.keyCode === 13) {
      setEditHandle();
    }
  };

  return (
    <div className="chat-info chat-info-visible">
      <div className="d-flex h-100 flex-column">
        <div className="chat-info-header px-2">
          <div className="container-fluid">
            <ul className="nav justify-content-between align-items-center">
              <li className="text-center">
                <h5 className="text-truncate mb-0">{i18n.t("profile.details")}</h5>
              </li>
              <li className="nav-item list-inline-item">
                <div
                  className="nav-link text-muted px-0 close-participant-profile-details"
                  href="#"
                  onClick={hideParticipantChatInfo}
                >
                  <svg className="hw-22" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className="hide-scrollbar flex-fill">
          {!groupId ? (
            !!personInfo && (
              <>
                <div className="text-center p-3">
                  <div className="avatar avatar-xl mx-5 mb-3">
                    <img className="avatar-img" src={personInfo.avatar} alt="" />
                  </div>
                  <h5 className="mb-1 username">{`${personInfo.name} ${personInfo.lastName}`}</h5>
                  {/* <p className="text-muted d-flex align-items-center justify-content-center">
                  <svg
                    className="hw-18 mr-1"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>
                  <span>{userInfo.city}</span>
                </p> */}
                </div>

                <div className="chat-info-group">
                  <div className="chat-info-group-header">
                    <h6 className="mb-0">{i18n.t("user.details")}</h6>
                    <svg className="hw-20 text-muted" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </div>
                  <div className="chat-info-group-body collapse show" id="profile-info">
                    <div className="chat-info-group-content list-item-has-padding">
                      <ul className="list-group list-group-flush ">
                        <li className="list-group-item border-0">
                          <p className="small text-muted mb-0">{i18n.t("role.names")}</p>
                          <p className="mb-0">{personInfo.rolesString.reduce((ac, i) => ac + i18n.t(roleNames[i]) + ",", "")}</p>
                        </li>
                        {personInfo.children && personInfo.children.length > 0 && (
                          <li className="list-group-item border-0">
                            <p className="small text-muted mb-0">{i18n.t("children")}</p>
                            <p className="mb-0">{personInfo.children.reduce((ac, val) => ac + val + ",", "")}</p>
                          </li>
                        )}
                        {personInfo.className && (
                          <li className="list-group-item border-0">
                            <p className="small text-muted mb-0">{i18n.t("class")}</p>
                            <p className="mb-0">{personInfo.className}</p>
                          </li>
                        )}
                        {personInfo.subjects && personInfo.subjects.length > 0 && (
                          <li className="list-group-item border-0">
                            <p className="small text-muted mb-0">{i18n.t("subjects")}</p>
                            <p className="mb-0">{personInfo.subjects.reduce((ac, val) => ac + val + ",", "")}</p>
                          </li>
                        )}
                        {personInfo.telePhone && (
                          <li className="list-group-item border-0">
                            <p className="small text-muted mb-0">{i18n.t("phone")}</p>
                            <p className="mb-0">{personInfo.telePhone}</p>
                          </li>
                        )}
                        {personInfo.mobile && (
                          <li className="list-group-item border-0">
                            <p className="small text-muted mb-0">{i18n.t("mobile")}</p>
                            <p className="mb-0">{personInfo.mobile}</p>
                          </li>
                        )}
                        {personInfo.email && (
                          <li className="list-group-item border-0">
                            <p className="small text-muted mb-0">{i18n.t("email")}</p>
                            <p className="mb-0">{personInfo.email}</p>
                          </li>
                        )}
                        {personInfo.address && (
                          <li className="list-group-item border-0">
                            <p className="small text-muted mb-0">{i18n.t("address")}</p>
                            <p className="mb-0">{personInfo.address}</p>
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              </>
            )
          ) : (
            <div className="hide-scrollbar flex-fill">
              <div className="border-bottom text-center p-3 cc_cursor">
                <div className="avatar bg-success text-light avatar-xl mx-5 mb-3">
                  <span>
                    <svg className="hw-50" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                      ></path>
                    </svg>
                  </span>
                </div>

                <div className="groupname-wrapper">
                  <div className="current-name">
                    <h5 className="mb-1">
                      <input
                        value={groupNameEdit}
                        type="text"
                        disabled={!editMode}
                        autoFocus
                        onChange={(e) => setGroupNameEdit(e.target.value)}
                        onKeyUp={determineEnterClick}
                      />
                    </h5>
                    {user.id === groupInfo.ownerId && (
                      <>
                        {editMode ? (
                          <div className="okay-btn" onClick={setEditHandle}>
                            <span className="material-icons">check</span>
                          </div>
                        ) : (
                          <div className="rename-btn" onClick={setEditHandle}>
                            <span className="material-icons">create</span>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>

                <p className="text-muted d-flex align-items-center justify-content-center">
                  <span>
                    <span className="material-icons">supervised_user_circle</span>
                  </span>

                  <span style={{ marginLeft: "5px", display: "inline-block" }}>
                    {groupInfo.personsCount} {i18n.t("participant")}
                  </span>
                </p>
                {user.id === groupInfo.ownerId && (
                  <div className="delete-group" onClick={() => deleteGroup(groupId)}>
                    {i18n.t("cancel.group")}
                  </div>
                )}
              </div>

              <div className="chat-info-group group-chat-members-block">
                <div className="chat-info-group-body collapse show" id="participants-list">
                  <div className="input-group">
                    <DebounceInput
                      placeholder={i18n.t("search")}
                      minLength={3}
                      debounceTimeout={1000}
                      className="form-control search border-right-0 transparent-bg pr-0"
                      type="text"
                      value={filter}
                      onChange={(e) => setFilter(e.target.value)}
                    />
                    <div className="input-group-append">
                      <div className="input-group-text transparent-bg border-left-0" role="button">
                        <svg className="text-muted hw-20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                          ></path>
                        </svg>
                      </div>
                    </div>
                  </div>
                  {user.id === groupInfo.ownerId && (
                    <div className="checkfor-onlygroup">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={onlyGroupMembers}
                            onChange={(e) => setOnlyGroupMembers(e.target.checked)}
                            name={i18n.t("onlyin.group")}
                          />
                        }
                        label={i18n.t("onlyin.group")}
                      />
                    </div>
                  )}
                  <div className="chat-info-group-content list-item-has-padding cc_cursor">
                    <Scrollbar
                      style={{ height: "300px" }}
                      onUpdate={() => onUpdateContactListScrollbar()}
                      ref={groupChatUsersScroll}
                    >
                      <ul className="list-group list-group-flush">
                        {contactsList.map((item) => (
                          <li className="list-group-item cc_cursor">
                            <div className="media align-items-center">
                              <div className="avatar mr-2">
                                <img src={item.avatar} alt="" />
                              </div>

                              <div className="media-body">
                                <h6 className="text-truncate username">{item.fullName}</h6>
                                <p className="text-muted mb-0 cc_cursor">
                                  {item.roles.length > 0 && item.roles.reduce((s, r) => s + `${i18n.t(roleNames[r])},`, "")}
                                </p>
                              </div>
                              {user.id !== item.id && user.id === groupInfo.ownerId && (
                                <div className="media-options ml-1">
                                  <div className="dropdown">
                                    {item.inGroup ? (
                                      <button
                                        onClick={() => removeFromGroup(item.id)}
                                        className="btn btn-secondary btn-icon btn-minimal btn-sm text-muted delete-btn"
                                        type="button"
                                      >
                                        <span className="material-icons">delete</span>
                                      </button>
                                    ) : (
                                      <button
                                        onClick={() => addToGroup(item.id)}
                                        className="btn btn-secondary btn-icon btn-minimal btn-sm text-muted add-btn"
                                        type="button"
                                      >
                                        <span className="material-icons">add_circle_outline</span>
                                      </button>
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>
                          </li>
                        ))}
                      </ul>
                    </Scrollbar>
                  </div>
                </div>
              </div>
            </div>
          )}
          {files && files.length > 0 && (
            <div className="chat-info-group">
              <div className="chat-info-group-header">
                <h6 className="mb-0">{i18n.t("documents")}</h6>
                <svg className="hw-20 text-muted" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                  />
                </svg>
              </div>
              <div className="chat-info-group-body collapse show" id="shared-files">
                <div className="chat-info-group-content chat-shared-files list-item-has-padding">
                  <Scrollbar>
                    <ul className="list-group list-group-flush">
                      {files &&
                        files.map((item, id) => (
                          <li className="list-group-item" key={id}>
                            <div className="document">
                              <div className="btn btn-primary btn-icon rounded-circle text-light mr-2">
                                <svg className="hw-24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                                  />
                                </svg>
                              </div>
                              <div className="document-body">
                                <h6 className="text-truncate">
                                  <a
                                    href={`/api/messenger/get-file?id=${item.id}`}
                                    className="text-reset"
                                    title={item.name}
                                    target="_blank"
                                  >
                                    {item.name}
                                  </a>
                                </h6>
                                <ul className="list-inline small mb-0">
                                  {/* <li className="list-inline-item">
                                <span className="text-muted">{item.size}</span>
                              </li> */}
                                  <li className="list-inline-item">
                                    <span className="text-muted text-uppercase">{item.type}</span>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </li>
                        ))}
                    </ul>
                  </Scrollbar>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ParticipantInfo;
